// src/AppRouter.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../Pages/home';

const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      
    </Routes>
  );
};

export default AppRouter;
